(function () {
  const shouldShowDebug = Shopify && theme.settings.uppromote_enable_debug && (Shopify.designMode || Shopify.previewMode);

  shouldShowDebug && console.log("Uppromote Fix v6 loaded");

  const applyDiscountCode = (discountCode) => {
    const lastChangedDiscount = localStorage.getItem("nh-uppromote-discount-last-changed") || 0;
    const lastChangedAffiliate = localStorage.getItem("nh-uppromote-affiliate-last-changed") || 0;
    if (lastChangedDiscount > lastChangedAffiliate) {
      console.log(
        "Not applying discount code because a discount code was applied more recently than an affiliate code.",
        lastChangedDiscount,
        lastChangedAffiliate,
      );
      return;
    }

    const saleCode = theme.settings.uppromote_sale_discount_code ? theme.settings.uppromote_sale_discount_code.trim() : null;
    const targetDiscount = saleCode && saleCode.length > 0 ? saleCode + "," + discountCode : discountCode;

    fetch(window.Shopify.routes.root + "cart/update.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ discount: "" }),
    })
      .then(() =>
        fetch(window.Shopify.routes.root + "cart/update.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ discount: targetDiscount }),
        }),
      )
      .then(async () => {
        const cartResponse = await fetch("/cart.js");
        const cart = await cartResponse.json();
        document.dispatchEvent(new CustomEvent("cart:updated", { detail: { cart } }));
      })
      .catch((error) => {
        console.warn("Uppromote Fix v6 - discount code could not be applied:", error);
      });
  };

  const dispatchCouponDetected = (affiliateId, coupon) => {
    document.dispatchEvent(
      new CustomEvent("uppromote:coupon-detected", {
        detail: { affiliateId: affiliateId.toString(), coupon },
      }),
    );
  };

  const couponLookupStarted = {};

  const getCouponCode = async () => {
    const searchParams = window.location.search;
    const queryParams = uppromote.parseQueryStringToObject(searchParams);
    shouldShowDebug && console.log("Uppromote Fix v6 - Current Search Params:", queryParams.sca_ref, queryParams.sca_rib);
    if (queryParams.sca_ref) {
      const refParts = queryParams.sca_ref.split(".");
      const trackingData = { aid: refParts[0], hc: refParts[1], s: uppromote.getShopName(), tid: localStorage.getItem("scaaf_tid"), ug: navigator.userAgent };
      const apiUrl = `${uppromote.host}/api/get_coupon`;
      const currentAffiliateId = trackingData.aid || uppromote.getCookie("scaaf_aid");

      shouldShowDebug && console.log("getCouponCode coupon code for:", trackingData.aid);
      if (trackingData.aid) {
        localStorage.setItem("nh-uppromote-affiliate-last-changed", Date.now().toString());
      }

      if (currentAffiliateId) {
        // v2: the first key could hold "no coupon" entries left behind by failed or interrupted requests.
        const couponCacheKey = "sb2026_coupon_cache_v2";
        let couponCache = {};
        try {
          couponCache = JSON.parse(localStorage.getItem(couponCacheKey) || "{}");
        } catch (e) {}

        let coupon = couponCache[currentAffiliateId];
        if (!Object.prototype.hasOwnProperty.call(couponCache, currentAffiliateId)) {
          // uppromote:loaded and uppromote:tracked-affiliate both end up here; one request per page load is enough.
          if (couponLookupStarted[currentAffiliateId]) return;
          couponLookupStarted[currentAffiliateId] = true;

          try {
            const response = await fetch(`/apps/affiliate/get_code/${currentAffiliateId}`);
            if (!response.ok) throw new Error(`Coupon lookup failed: ${response.status}`);
            const data = await response.json();
            coupon = data.coupon || null;
            // Only a real answer is stored, so a failed request is asked again on the next page load.
            couponCache[currentAffiliateId] = coupon;
            localStorage.setItem(couponCacheKey, JSON.stringify(couponCache));
          } catch (e) {
            coupon = null;
          }
        }

        if (coupon) {
          applyDiscountCode(coupon);
          dispatchCouponDetected(currentAffiliateId, coupon);
          shouldShowDebug && console.log("Applied coupon code from Uppromote:", coupon);
          return;
        }
      }
    } else {
      shouldShowDebug && console.log("No sca_ref parameter found in URL. Not applying any coupon code.");
    }
  };

  // needed to trigger events
  window.UppromoteCustomerReferral = true;

  let setNHAffTimeout;

  window.addEventListener("uppromote:loaded", function (event) {
    if (new URLSearchParams(window.location.search).has("sca_ref")) {
      getCouponCode();
    }

    setNHAffTimeout = setTimeout(async () => {
      // Check for aff_code first — it should always override existing tracking
      const urlParams = new URLSearchParams(window.location.search);
      const code = urlParams.get("aff_code");

      if (code && code.trim().length) {
        // v2 for the same reason as the coupon cache.
        const affiliateCodeCacheKey = "nh-uppromote-affiliate-code-cache-v2";
        let affiliateCodeCache = {};
        try {
          affiliateCodeCache = JSON.parse(localStorage.getItem(affiliateCodeCacheKey) || "{}");
        } catch (e) {}

        let affiliateData = affiliateCodeCache[code];
        if (!Object.prototype.hasOwnProperty.call(affiliateCodeCache, code)) {
          try {
            const isAffiliateCodeResponse = await fetch(`/apps/affiliate/get_affiliate/${encodeURIComponent(code)}`);
            if (!isAffiliateCodeResponse.ok) throw new Error(`Affiliate lookup failed: ${isAffiliateCodeResponse.status}`);
            affiliateData = await isAffiliateCodeResponse.json();
            affiliateCodeCache[code] = affiliateData;
            localStorage.setItem(affiliateCodeCacheKey, JSON.stringify(affiliateCodeCache));
          } catch (e) {
            affiliateData = null;
          }
        }

        const { affiliateId, disableTracking } = affiliateData || {};

        if (affiliateId) {
          shouldShowDebug && console.log("Affiliate tracking detected from URL parameter, applying discount code for affiliate:", affiliateId);
          localStorage.setItem("nh-uppromote-affiliate-last-changed", Date.now().toString());
          applyDiscountCode(code);
          dispatchCouponDetected(affiliateId, code);

          if (disableTracking) {
            shouldShowDebug &&
              console.log("Tracking is disabled for this affiliate code, setting affiliate ID to default nature heart ID for tracking purposes.");
          }

          const trackingData = {
            aid: disableTracking ? "7381745" : affiliateId.toString(),
            hc: "BMhivuwKscYYb",
            s: uppromote.getShopName(),
            ug: navigator.userAgent,
          };
          uppromote.setLocalTrackingVariables(trackingData.aid, false, trackingData.hc, new Date().getTime());
          localStorage.setItem("up_uppromote_aid", trackingData.aid);
          uppromote.setCookie("up_uppromote_aid", trackingData.aid, 30);
          uppromote.postClickTracking(trackingData, null);
          return;
        }
      }

      if (localStorage.getItem("scaaf_received") === null) {
        /*
        // default nh tracking
        shouldShowDebug && console.log("No affiliate tracking detected, setting default tracking to nature heart");
        const trackingData = {
          aid: "7381745",
          hc: "BMhivuwKscYYb",
          s: uppromote.getShopName(),
          ug: navigator.userAgent,
        };
        uppromote.setLocalTrackingVariables(trackingData.aid, false, trackingData.hc, new Date().getTime());
        localStorage.setItem("up_uppromote_aid", trackingData.aid);
        uppromote.setCookie("up_uppromote_aid", trackingData.aid, 30);
        uppromote.postClickTracking(trackingData, null);
        */
      } else {
        shouldShowDebug &&
          console.log("Affiliate tracking detected, no need to set default tracking nature heart. Existing Aff:  ", uppromote.getCookie("scaaf_afn"));
      }
    }, 4000);
  });

  // kind of a race condition with the uppromote script, but the event gets fired with a 500ms delay anyways so we should always be good
  window.addEventListener("uppromote:tracked-affiliate", function (event) {
    if (setNHAffTimeout) {
      shouldShowDebug && console.log("Clearing default affiliate timeout as an affiliate was tracked.");
      clearTimeout(setNHAffTimeout);
    }
    shouldShowDebug && console.log("Applying discount code from Uppromote:", event);
    getCouponCode();
  });
})();
